module.exports = fox._r("images/offer/acp/freeacp/bbw/logo.png", __webpack_public_path__ + "_/_/_/root/images/offer/acp/freeacp/bbw/logo.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/offer/acp/freeacp/bbw/logo.png
// module id = 761
// module chunks = 4